module.exports = __webpack_public_path__ + "youtube.png?a1efa664f2f4030343ddf684829a697d";